import React, { useState, useEffect } from 'react'
import {
  Button, Label, Input,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap'
import _ from 'lodash'
import { toast } from 'react-toastify'

import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import Lang from 'Lang/General'

const NewsletterTest = props => {
  const [ recipientEmail, setRecipientEmail ] = useState('')

  useEffect(() => {
    if( !props.showTestNewsletterModal ){
      setRecipientEmail('')
    }
  }, [ props.showTestNewsletterModal ])

  return (
    <Modal
      size='sm'
      isOpen={ props.showTestNewsletterModal } >
      <ModalHeader toggle={ () => props.onChangeNewsletterHOC('showTestNewsletterModal', false) }>
        { Lang[ 'TEST_NEWSLETTER_SENDING' ][ props.data.languageReducer.userSettings.admin_panel_language ] }
      </ModalHeader>
      <ModalBody>
        <Label>{ Lang[ 'RECIPIENT_EMAIL' ][ props.data.languageReducer.userSettings.admin_panel_language ] }</Label>
        <Input 
          type="email" 
          value={ recipientEmail } 
          onChange={ (e) => setRecipientEmail(e.target.value) } 
        />
        { props.onLoadNewsletters && <LoadingOverlay /> }
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={ () => {
            const langCode = props.data.languageReducer.userSettings.admin_panel_language
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if ( !recipientEmail || !re.test( recipientEmail ) ) {
              toast.error( Lang[ 'PLEASE_ENTER_VALID_EMAIL' ][ langCode ] )
              return
            }
            let tmp = _.cloneDeep( props.newNewsletterData )
            props.emailEditor.exportHtml((data) => {
              const { design, html } = data
              tmp.json_content = design
              tmp.html_content = html
              tmp.domain = window.location.origin
              tmp.test_send_email = recipientEmail
              props.testSendNewsletter( tmp ) 
            });
          }}>
          { Lang[ 'SUBMIT' ][ props.data.languageReducer.userSettings.admin_panel_language ] }
        </Button>
      </ModalFooter>
    </Modal>
  )
}
export default NewsletterTest
